"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LOG_PREFIX = 'PeerJS: ';
/*
Prints log messages depending on the debug level passed in. Defaults to 0.
0  Prints no logs.
1  Prints only errors.
2  Prints errors and warnings.
3  Prints all logs.
*/
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Disabled"] = 0] = "Disabled";
    LogLevel[LogLevel["Errors"] = 1] = "Errors";
    LogLevel[LogLevel["Warnings"] = 2] = "Warnings";
    LogLevel[LogLevel["All"] = 3] = "All";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
class Logger {
    constructor() {
        this._logLevel = LogLevel.Disabled;
    }
    get logLevel() { return this._logLevel; }
    set logLevel(logLevel) { this._logLevel = logLevel; }
    log(...args) {
        if (this._logLevel >= LogLevel.All) {
            this._print(LogLevel.All, ...args);
        }
    }
    warn(...args) {
        if (this._logLevel >= LogLevel.Warnings) {
            this._print(LogLevel.Warnings, ...args);
        }
    }
    error(...args) {
        if (this._logLevel >= LogLevel.Errors) {
            this._print(LogLevel.Errors, ...args);
        }
    }
    setLogFunction(fn) {
        this._print = fn;
    }
    _print(logLevel, ...rest) {
        const copy = [LOG_PREFIX, ...rest];
        for (let i in copy) {
            if (copy[i] instanceof Error) {
                copy[i] = "(" + copy[i].name + ") " + copy[i].message;
            }
        }
        if (logLevel >= LogLevel.All) {
            console.log(...copy);
        }
        else if (logLevel >= LogLevel.Warnings) {
            console.warn("WARNING", ...copy);
        }
        else if (logLevel >= LogLevel.Errors) {
            console.error("ERROR", ...copy);
        }
    }
}
exports.default = new Logger();
